import { amountFormatter } from 'bog-arcade-core-ui/helpers/amountFormatter';
import { partnerService } from '../../services/helperServices/PartnerService';

export const getAmount = (amount) => `${amountFormatter.format(amount)} ${partnerService.displayCurrency}`;